<div [cxFocus]="focusConfig" (esc)="closeDialog('Escape clicked')" class="service-parts-search-dialog">
  <div class="service-parts-search-dialog-container">
    <!-- Modal Header -->
    <div class="modal-header service-parts-search-dialog-header">
      <div class="service-parts-search-dialog-header-icon-container">
        <img class="service-parts-search-dialog-header-icon" src="../../../../../assets/icons/sp-search-orange.svg">
      </div>
      <div class="service-parts-search-dialog-header-title modal-title">
        <h3>{{ 'spSearchDialog.title' | cxTranslate }}</h3>
        <h4>{{ 'spSearchDialog.subTitle' | cxTranslate }}</h4>
      </div>

      <button (click)="closeDialog('Close Dialog')" [attr.aria-label]="'common.close' | cxTranslate"
        class="service-parts-search-dialog-header-close close" type="button">
        <img class="" src="../../../../../../../assets/icons/close_black_24.svg">
      </button>
    </div>

    <!-- Modal Body -->
    <div class="service-parts-search-dialog-body">
      <div class="sp-search-results">
        <div class="sp-search-results-tabs">
          <div class="desktop-tab-paragraph-container">
            <ul genHorizontalScrollOverflowHide class="desktop-tab-paragraph-tabs">
              <ng-container *ngFor="let item of SP_SEARCH_CRITERIAS; let i = index">
                <li class="desktop-tab-paragraph-tab" (click)="selectSpSeachTab(item.value)">
                  <a>
                    <img src="{{'../../../../../assets/icons/sp-search-' + item.value + '.svg'}}">
                    <input [id]="'tabReference_' + i" type="radio" name="tab-references" [value]="item.value" />
                    <label [class.active]="activeSpSearchCriteria === item.value" [for]="'tabReference_' + i"
                      role="tab">By
                      {{ item.name }}</label>
                  </a>
                </li>
              </ng-container>
            </ul>
          </div>
        </div>

        <span class="sp-search-results-selected-criteria">{{ (activeSpSearchCriteria === 'model' ?
          'spSearchDialog.modelNumber' : 'spSearchDialog.serialNumber') |
          cxTranslate }}</span>
        <gen-searchbox [isSpSearch]="true" [activeSpSearchCriteria]="activeSpSearchCriteria"
          (spSearchProductSelected)="selectSpSearchProduct($event)"></gen-searchbox>

        <div *ngIf="activeSpSearchCriteria === 'model' && selectedSpSearchProduct?.code" class="selected-model">
          <div class="selected-model-info">
            <span class="selected-model-info-name">{{selectedSpSearchProduct.code}} -
              {{selectedSpSearchProduct.name}}</span>
            <span class="selected-model-info-category">{{selectedSpSearchProduct.categories ?
              selectedSpSearchProduct.categories[0]?.name : ''}}</span>
          </div>
          <img src="../../../../../assets/icons/white_check_circle_orange.svg" class="sp-search-model-icon">
        </div>

        <div *ngIf="activeSpSearchCriteria === 'serial-number'" class="serial-number-location">
          <p class="where-find">{{ 'spSearchDialog.whereFindSerialNumber' | cxTranslate }}</p>
          <p class="serial-number">{{ 'spSearchDialog.serialNumberLocation' | cxTranslate }}</p>
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="service-parts-search-dialog-footer">
      <p>{{ 'spSearchDialog.serialNumberHint' | cxTranslate }}</p>
      <button class="btn btn-primary" [disabled]="!selectedSpSearchProduct?.code" (click)="navigateToSpSearch()">
        {{ 'spSearchDialog.viewParts' | cxTranslate }}</button>
    </div>
  </div>